import React, { useState } from 'react';
import { X, Flower } from 'lucide-react';
import { RadioListOneColumn } from '../ui/RadioListOneColumn';
import { useSticker } from '../../context/StickerContext';
import { useToast } from '../ui/Toast';
export function CutlinePanel() {
  const {
    cutline,
    setCutline
  } = useSticker();
  const {
    addToast
  } = useToast();
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [precision, setPrecision] = useState('Medium');
  const handlePrecisionChange = (val: string) => {
    setPrecision(val);
    addToast('Updating cutline...');
  };
  return <div className="h-full flex flex-col" data-id="element-36">
      <div className="p-4 border-b border-gray-100 flex items-center justify-between" data-id="element-37">
        <h2 className="font-semibold text-gray-900" data-id="element-38">Cutline</h2>
        <button className="text-xs text-violet-600 font-medium hover:text-violet-700" data-id="element-39">
          Upload new file
        </button>
      </div>

      <div className="p-4 space-y-6 overflow-y-auto flex-1" data-id="element-40">
        {/* Toggle */}
        <div className="flex items-center justify-between" data-id="element-41">
          <span className="text-sm font-medium text-gray-700" data-id="element-42">
            Show cutout suggestions
          </span>
          <button onClick={() => setShowSuggestions(!showSuggestions)} className={`w-11 h-6 rounded-full transition-colors relative ${showSuggestions ? 'bg-violet-600' : 'bg-gray-200'}`} data-id="element-43">
            <div className={`w-4 h-4 bg-white rounded-full absolute top-1 transition-transform ${showSuggestions ? 'left-6' : 'left-1'}`} data-id="element-44" />
          </button>
        </div>

        {/* Basic Shapes */}
        <div className="space-y-3" data-id="element-45">
          <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-46">
            Basic Shapes
          </label>
          <RadioListOneColumn name="cutline_shape" options={['Cut to Outline', 'Square', 'Rounded Square', 'Circle', 'Rectangle', 'Rounded Corners', 'Ellipse']} value={cutline} onChange={val => {
          setCutline(val as any);
          addToast('Updating cutline...');
        }} data-id="element-47" />
        </div>

        {/* Precision */}
        <div className="space-y-3" data-id="element-48">
          <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-49">
            Cutline precision
          </label>
          <div className="grid grid-cols-3 gap-2" data-id="element-50">
            {['Loose', 'Medium', 'Tight'].map(opt => {
            const isSelected = precision === opt;
            return <button key={opt} onClick={() => handlePrecisionChange(opt)} className={`
                    flex flex-col items-center justify-center p-3 rounded-lg border transition-all
                    ${isSelected ? 'border-violet-600 bg-violet-50 ring-1 ring-violet-600' : 'border-gray-200 hover:bg-gray-50'}
                  `} data-id="element-51">
                  <Flower size={20} className={`mb-2 ${isSelected ? 'text-violet-600' : 'text-gray-400'}`} data-id="element-52" />
                  <span className={`text-xs font-medium ${isSelected ? 'text-violet-900' : 'text-gray-600'}`} data-id="element-53">
                    {opt}
                  </span>
                </button>;
          })}
          </div>
        </div>
      </div>
    </div>;
}